import React from 'react'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { ReactComponent as Logo } from '../../assets/logo.svg'
import { errorBoundaryStyles } from './error-boundary.styles'
import { useRouter } from 'next/router'
import { useTranslation } from '@plandi/common'

export const ErrorBoundaryComponent = () => {
  const classes = errorBoundaryStyles()
  const router = useRouter()
  const { data: translation } = useTranslation()

  const handleReloadPage = () => {
    router.reload()
  }

  return (
    <div className={classes.root}>
      <Logo className={classes.logo} />
      <Typography variant="h3" gutterBottom>
        {translation?.['something-went-wrong'] ?? 'Похоже что-то пошло не так'}
      </Typography>
      <Typography variant="body1" className={classes.subTitle}>
        {translation?.['regularly-contact-technical-support'] ??
          `Если данное сообщение появляется регулярно, пожалуйста, свяжитесь с
        нашей техподдержкой`}
      </Typography>
      <Button
        onClick={handleReloadPage}
        color="secondary"
        variant="contained"
        size="large"
      >
        {translation?.['reload-page'] ?? 'Перезагрузить страницу'}
      </Button>
    </div>
  )
}
